import { Bio } from "./Bio/Bio";

export const PortfolioLeft = () => {
  return (
    <div className="portfolio-left-container">
      <Bio />
    </div>
  );
};
